export const ApiUsersUrls = {
  list: '/users',
  retrieve: '/users/:id',
  activeUser: '/users/active-user',
};
